import {
    Button,
    Flex,
    InputGroup,
    Modal,
    Text,
} from '@raskrask-dk/rr-components'
import { t } from 'i18next'

export interface ICancelBookModalProps {
    shouldPayCancellationFee: boolean
    hasCustomerAgreedToCancellationFee: boolean
    setHasCustomerAgreedToCancellationFee: (val: boolean) => void
    numberOfHoursUntillServiceDate: number
    showCancelBookModal: boolean
    setShowCancelBookingModal: (val: boolean) => void
    onClickCancelBooking: () => void
}

export const CancelBookingModal = ({
    numberOfHoursUntillServiceDate,
    hasCustomerAgreedToCancellationFee,
    setHasCustomerAgreedToCancellationFee,
    shouldPayCancellationFee,
    showCancelBookModal,
    setShowCancelBookingModal,
    onClickCancelBooking,
}: ICancelBookModalProps): React.ReactFragment => {
    // Texts. Checkbox
    const cancellationFeeSize =
        numberOfHoursUntillServiceDate < 6
            ? 100
            : numberOfHoursUntillServiceDate > 6 &&
              numberOfHoursUntillServiceDate < 24
            ? 50
            : 0
    const dynamicCancellationFeeExplanationText =
        cancellationFeeSize === 50
            ? t('cancellationfee.50percent.explanation.text')
            : cancellationFeeSize === 100
            ? t('cancellationfee.100percent.explanation.text')
            : ''
    const cancellationFeeComponent = (
        <Flex direction={'column'} gap={'32'}>
            <Text bold>
                {/* {t('cancellationfee.hourstotreatment.text')} */}
                {numberOfHoursUntillServiceDate} Timer til behandlingen.
            </Text>
            <Text data-cy={`${cancellationFeeSize}feeexplanation`}>
                {dynamicCancellationFeeExplanationText}
            </Text>
            <InputGroup
                label={'Bekræft at du er indforstået med aflysningsgebyret'}
                labelPlacement={'start'}
                type="checkbox"
                id="Hallihallo"
                data-cy={'CancellationFeeAcceptCheckBox'}
                onChange={() =>
                    setHasCustomerAgreedToCancellationFee(
                        !hasCustomerAgreedToCancellationFee
                    )
                }
            ></InputGroup>
        </Flex>
    )

    const defaultTextElement = () => {
        return <Text>Er du sikker på at du ønsker at aflyse?</Text>
    }

    const isCTAClickable =
        hasCustomerAgreedToCancellationFee || !shouldPayCancellationFee
    return (
        <Modal open={showCancelBookModal}>
            <Flex direction={'column'} gap={'16'}>
                <Flex direction={'column'} gap={'16'}>
                    {shouldPayCancellationFee ? (
                        cancellationFeeComponent
                    ) : (
                        <></>
                    )}
                    {defaultTextElement()}
                </Flex>
                <Flex direction={'row'} gap={'8'} justifyContent={'center'}>
                    <Button
                        disabled={!isCTAClickable}
                        variant={'danger'}
                        data-cy={'ModalCancelbookingButton'}
                        onClick={() => onClickCancelBooking()}
                    >
                        {t('cancelbooking.button.text')}
                    </Button>
                    <Button
                        variant={'default'}
                        onClick={() => setShowCancelBookingModal(false)}
                    >
                        {t('cancelbooking.gobackbutton.text')}
                    </Button>
                </Flex>
            </Flex>
        </Modal>
    )
}
